export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const AUTH = {
  loginForm: 'auth-login-form',
  loginEmail: 'auth-login-email',
  loginPassword: 'auth-login-password',
  loginSubmit: 'auth-login-submit',
  registerForm: 'auth-register-form',
  registerEmail: 'auth-register-email',
  registerPassword: 'auth-register-password',
  registerName: 'auth-register-name',
  registerInstitution: 'auth-register-institution',
  registerSubmit: 'auth-register-submit',
  switchToRegister: 'auth-switch-to-register',
  switchToLogin: 'auth-switch-to-login',
};

export const DASHBOARD = {
  container: 'dashboard-container',
  logoutBtn: 'dashboard-logout-btn',
  navPatients: 'dashboard-nav-patients',
  navTherapists: 'dashboard-nav-therapists',
  navResources: 'dashboard-nav-resources',
  navReports: 'dashboard-nav-reports',
  navAppointments: 'dashboard-nav-appointments',
  navInstitution: 'dashboard-nav-institution',
};

export const PATIENTS = {
  addBtn: 'patients-add-btn',
  list: 'patients-list',
  nameInput: 'patient-name-input',
  saveBtn: 'patient-save-btn',
  deleteBtn: 'patient-delete-btn',
};

export const THERAPISTS = {
  addBtn: 'therapists-add-btn',
  list: 'therapists-list',
  nameInput: 'therapist-name-input',
  emailInput: 'therapist-email-input',
  saveBtn: 'therapist-save-btn',
};

export const REPORTS = {
  createBtn: 'reports-create-btn',
  list: 'reports-list',
  exportPdfBtn: 'report-export-pdf-btn',
  saveBtn: 'report-save-btn',
};

export const APPOINTMENTS = {
  createBtn: 'appointments-create-btn',
  calendar: 'appointments-calendar',
  saveBtn: 'appointment-save-btn',
};
